import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinGetCollectionParamsSchema = ActionCommonParamsSchema.extend({
    keyword: z.string().optional(),
    count: z.number().optional(),
});

export type DouyinGetCollectionParams = z.infer<typeof DouyinGetCollectionParamsSchema>;
